/**
 * Route for `igaming-regulator-audit-extract-mga-ukgc-cura-ao-f`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingRegulatorAuditExtractMgaUkgcCuraAoFPage } from "../features/igaming-regulator-audit-extract-mga-ukgc-cura-ao-f/IgamingRegulatorAuditExtractMgaUkgcCuraAoFPage";

export const igamingRegulatorAuditExtractMgaUkgcCuraAoFRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-regulator-audit-extract-mga-ukgc-cura-ao-f",
	component: IgamingRegulatorAuditExtractMgaUkgcCuraAoFPage,
});

export default igamingRegulatorAuditExtractMgaUkgcCuraAoFRoute;
